/**
 * <footer-credit> — il pallino della pillola scorre da sinistra a destra,
 * poi si va al sito.
 *
 * La navigazione avviene nella stessa scheda: con target="_blank" bisognerebbe
 * chiamare window.open dopo l'animazione, cioe' fuori dal gesto dell'utente,
 * e i blocchi popup lo fermerebbero. I clic con modificatori (ctrl, cmd, rotella)
 * non passano di qui e mantengono il comportamento nativo del browser.
 */
if (!customElements.get('footer-credit')) {
  customElements.define(
    'footer-credit',
    class FooterCredit extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('.footer-credit__link');
        this.knob = this.querySelector('.footer-credit__knob');
        if (!this.link) return;

        this.onClick = this.onClick.bind(this);
        this.link.addEventListener('click', this.onClick);
      }

      disconnectedCallback() {
        this.link?.removeEventListener('click', this.onClick);
        clearTimeout(this.timer);
      }

      onClick(event) {
        // lascio al browser i clic che l'utente vuole gestire a modo suo
        if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) {
          return;
        }

        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (reduced || !this.knob || this.navigating) return;

        event.preventDefault();
        this.navigating = true;
        this.classList.add('is-on');

        const go = () => {
          clearTimeout(this.timer);
          window.location.href = this.link.href;
        };

        // transitionend e' la via normale; il timeout copre il caso in cui
        // l'evento non arrivi, per esempio se la transizione viene interrotta
        this.knob.addEventListener('transitionend', go, { once: true });
        this.timer = setTimeout(go, 700);
      }
    }
  );
}
